import {
  useMutation,
  useQueryClient,
  UseMutationResult,
  UseMutationOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type { EventTicketTierDto, ResponseDto } from "@mimber/schema"
import { eventTicketTiersKeys } from "../events.utils"

export const useDeactivateEventTicketTier = (
  eventUuid: string,
  options?: UseMutationOptions<ResponseDto<EventTicketTierDto>, Error, string>
): UseMutationResult<ResponseDto<EventTicketTierDto>, Error, string> => {
  guardAppUsage("mimber-organization", "useDeactivateEventTicketTier")

  const { server } = useServerContext()
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: async (tierUuid: string) => {
      const response = await server.post<ResponseDto<EventTicketTierDto>>(
        `events/${eventUuid}/ticket-tiers/${tierUuid}/deactivate`
      )
      return response.data
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({
        queryKey: eventTicketTiersKeys.findAll(eventUuid),
      })
      options?.onSuccess?.(data, variables, onMutateResult, context)
    },
  })
}
